import React from 'react'
import moment from 'moment'
import { sumBy } from 'lodash'
import firebase from 'firebase/app'
import { Table, Segment, Header, Menu, Icon, Label } from 'semantic-ui-react'

import RealTimeTracker from '../../../components/common/tracker'
import DateRangeSearch from './DateRangeSearch'
import CreditModal from './CreditModal'

class CreditTab extends React.Component {
  state = {
    from: moment().startOf('day').format('x'),
    to: moment().endOf('day').format('x'),

    loading: false,
    filter: 'all',
    transactions: {},

    modalCreditVisible: false,
  }

  componentDidMount() {
    this.subscription = null
    this.getCredits()
  }

  componentWillUnmount() {
    if (this.subscription) this.subscription.off()
  }

  onSearchTransactions = () => {
    const { from, to } = this.state

    if (from === '' || to === '') {
      // eslint-disable-next-line no-alert
      alert('Please select date')
      return;
    }

    if (this.subscription) this.subscription.off()

    this.getCredits(from, to)
  }

  getCredits = () => {
    const { driverUid } = this.props
    const { from, to } = this.state

    this.setState({ loading: true })

    this.subscription = firebase
      .database()
      .ref(`deliverer_credits/${driverUid}`)
      .orderByChild('created_at')
      .startAt(parseInt(from, 10))
      .endAt(parseInt(to, 10))

    this.subscription.on('value', snapshot => {
      const transactions = {}

      if (snapshot.val() !== null) {

        snapshot.forEach(transactionSnapshot => {
          const transaction = transactionSnapshot.val()
          const { key } = transactionSnapshot

          transactions.all = transactions.all || []
          transactions[transaction.type] = transactions[transaction.type] || []

          transactions.all.unshift({ ...transaction, key })
          transactions[transaction.type].unshift({ ...transaction, key })
        })
      }

      this.setState({ transactions, loading: false })
    })
  }


  getTotalCredit = () => {
    const { filter, transactions } = this.state
    const totalCredit = sumBy(transactions[filter] || [], 'value')

    return `Total: $ ${parseFloat(totalCredit).toFixed(2)}`
  }

  getDriverCredit = walletType => {
    const { driver } = this.props
    const balanceField = `${walletType}_balance`

    if (driver)
      return `$ ${parseFloat(driver[balanceField] || 0).toFixed(2)}`

    return '$ 0.00'
  }

  renderCreditValue = credit => {
    const color = credit.value > 0 ? 'green' : 'red'

    return (
      <Label color={color}>
        {`$ ${parseFloat(credit.value).toFixed(2)}`}
      </Label>
    )
  }

  renderRow = (transaction, index) => {
    const displayHandler = typeof transaction.handler === 'object'
                            ? transaction.handler.order_number ||
                              transaction.handler.order_key ||
                              transaction.handler.order
                            : transaction.handler
    const createdAt = {
      date: moment(transaction.created_at).format('DD-MM-YYYY'),
      time: moment(transaction.created_at).format('HH:mm a')
    }

    return (
      <Table.Row key={index}>
        <Table.Cell textAlign="center">{this.renderCreditValue(transaction)}</Table.Cell>
        <Table.Cell textAlign="center">{transaction.description || '...'}</Table.Cell>
        <Table.Cell textAlign="center">
          <div>{createdAt.date}</div>
          <div>{createdAt.time}</div>
        </Table.Cell>
        <Table.Cell textAlign="center">{displayHandler}</Table.Cell>
      </Table.Row>
    )
  }

  renderNoResult = () => (
    <Table.Row>
      <Table.Cell colSpan={4} textAlign="center">
        No results
      </Table.Cell>
    </Table.Row>
  )

  renderRows = () => {
    const { transactions, filter } = this.state
    const displayTransactions = (transactions[filter] || []).map(this.renderRow)

    return displayTransactions.length > 0 && displayTransactions
  }

  render() {
    const { auth, roles, driverUid, driver } = this.props
    const { from, to, filter, loading, modalCreditVisible } = this.state

    const startFrom = moment(parseInt(from, 10)).format("YYYY-MM-DD")
    const endAt = moment(parseInt(to, 10)).format("YYYY-MM-DD")

    const isSuperAdmin = roles[auth.role] && roles[auth.role].name === 'Super Admin'
    const hasAccess = (roles[auth.role] ? roles[auth.role].access : []).includes('credit')

    return (
      <div>
        <div className='ui equal width grid'>
          <div className='column'>
            <RealTimeTracker
              label="Credit Wallet"
              icon="money"
              actualValue={this.getDriverCredit('credit')}
              loaded
            />
          </div>
          <div className='column'>
            <RealTimeTracker
              label="Cash Wallet"
              icon="money"
              actualValue={this.getDriverCredit('cash')}
              loaded
            />
          </div>
        </div>

        <Segment color='black' style={{ marginBottom: 20 }}>
          <Header size='large' style={{ display: 'inline-block' }}> Credit Transactions </Header>

          <Menu size="small" icon='labeled' style={{ marginTop: 0 }}>
            <Menu.Item
              name='deposit'
              active={filter === 'all'}
              onClick={() => this.setState({ filter: 'all' })}
            >
              <Icon name='clipboard list' />
              All Transactions
            </Menu.Item>
            <Menu.Item
              name='deposit'
              active={filter === 'deposit'}
              onClick={() => this.setState({ filter: 'deposit' })}
            >
              <Icon name='dollar sign' />
              Deposit
            </Menu.Item>

            <Menu.Item
              name='commission'
              active={filter === 'commission'}
              onClick={() => this.setState({ filter: 'commission' })}
            >
              <Icon name='percent' />
              Commission
            </Menu.Item>

            <Menu.Item
              name='deliveryFee'
              active={filter === 'deliveryFee'}
              onClick={() => this.setState({ filter: 'deliveryFee' })}
            >
              <Icon name='motorcycle' />
              Delivery fee
            </Menu.Item>

            <Menu.Item
              name='cashOut'
              active={filter === 'cashOut'}
              onClick={() => this.setState({ filter: 'cashOut' })}
            >
              <Icon name='money' />
              Cash Out
            </Menu.Item>

            {
              (isSuperAdmin || hasAccess) &&
              <Menu.Menu position='right'>
                <Menu.Item name='addCredit' onClick={() => this.setState({ modalCreditVisible: true })}>
                  <Icon name='add' />
                  Add Credit
                </Menu.Item>
              </Menu.Menu>
            }
          </Menu>

          <Segment>
            <DateRangeSearch
              style={{ display: 'inline-block' }}
              start={startFrom}
              end={endAt}
              loading={loading}
              onButtonClick={this.onSearchTransactions}
              onStartChange={value => this.setState({ from: value })}
              onEndChange={value => this.setState({ to: value })}
            />
            {
              filter !== 'all' && (
                <div style={{ float: 'right', marginTop: 10 }}>
                  <Header size="medium">
                    {this.getTotalCredit()}
                  </Header>
                </div>
              )
            }
          </Segment>

          <Table basic='very'>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell style={{ width: "30%" }} textAlign="center">Value</Table.HeaderCell>
                <Table.HeaderCell style={{ width: "30%" }} textAlign="center">Description</Table.HeaderCell>
                <Table.HeaderCell style={{ width: "20%" }} textAlign="center">Created at</Table.HeaderCell>
                <Table.HeaderCell style={{ width: "20%" }} textAlign="center">Handler</Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            <Table.Body>
              {this.renderRows() || this.renderNoResult()}
            </Table.Body>
          </Table>
        </Segment>

        <CreditModal
          creditBalance={driver.credit_balance}
          cashBalance={driver.cash_balance}
          visible={modalCreditVisible}
          driverUid={driverUid}
          auth={auth}
          onClose={() => this.setState({ modalCreditVisible: false })}
        />
      </div>
    )
  }
}

export default CreditTab



// WEBPACK FOOTER //
// ./src/containers/drivers/detail/CreditTab.js